import { render, staticRenderFns } from "./alert-big-icon.vue?vue&type=template&id=c978e7ba"
import script from "./alert-big-icon.vue?vue&type=script&lang=js"
export * from "./alert-big-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports